import { FC } from 'react';

import Button from '@/components/elements/Button';
import Container from '@/components/elements/Container';
import Heading from '@/components/elements/Heading';
import NewsletterForm from '@/components/elements/NewsletterForm';
import Section from '@/components/elements/Section';
import Text from '@/components/elements/Text';

export interface CallToActionProps {
  uid: any;
  heading: any;
  text: any;
  actions: any;
}

const CallToAction: FC<CallToActionProps> = ({
  uid,
  heading,
  text,
  actions,
}) => {
  return (
    <Section key={uid} gapTop="sm" gapBottom="sm" className="not-prose">
      <Container size="sm" gutter="none">
        <div className="relative w-full rounded-xl bg-neutral-100 p-5 text-left dark:bg-neutral-800 md:p-6 lg:flex lg:items-center lg:justify-between lg:p-8 xl:p-10 2xl:p-14">
          <div className="flex flex-col gap-2">
            <Heading
              element="h2"
              size="sm"
              color="dark"
              className="!m-0 !max-w-none"
            >
              {heading}
            </Heading>
            <Text size="lg" className="!m-0 !max-w-none">
              {text}
            </Text>
          </div>
          {actions && (
            <div className="flex gap-x-3">
              {actions.map((action) => (
                <>
                  {action.component === 'elementNewsletterSubscription' && (
                    <NewsletterForm key={action._uid} />
                  )}
                  {action.component === 'elementAction' && (
                    <Button
                      key={action._uid}
                      link={action.link}
                      style={action.style}
                    >
                      {action.label}
                    </Button>
                  )}
                </>
              ))}
            </div>
          )}
        </div>
      </Container>
    </Section>
  );
};

export default CallToAction;
